import React, { useState, useEffect } from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6

import ImageUploader from "../imageuploader";

import { apiDelete, apiGet, apiPost, apiPut } from "../../api/server"


const CreateOffer = (props) => {

  const listOffers = (e) => {
    props.setUpdateOrCreate("n")
  }

  const modules={
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{ 'header': 1 }, { 'header': 2 }],               // custom button values
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
      [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
      [{ 'direction': 'rtl' }],                         // text direction

      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'font': [] }],
      [{ 'align': [] }],
      ['link'],

      ['clean']     
    ],
  }
    const [offer, setOffer] = useState();
    const [name, setName] = useState();
    const [company, setCompany] = useState();
    const [headline, setHeadline] = useState();
    const [details, setDetails] = useState("");
    const [published, setPublished] = useState(false);
    const [livedate, setLivedate] = useState();
    const [enddate, setEnddate] = useState();
    const [imageurl, setImageurl] = useState();

    useEffect(() => {
      apiGet(`intranetoffers/getofferbyid/?id=${props.id}`).then(res => {
      res.json().then(data => {
          console.log(data)
          setOffer(data.results[0])
          setName(data.results[0].name)
          setCompany(data.results[0].company)
          setHeadline(data.results[0].headline)
          setDetails(data.results[0].details)
          setPublished(data.results[0].published)
          setLivedate(data.results[0].livedate)
          setEnddate(data.results[0].edndate)
          setImageurl(data.results[0].imageurl)
      })
      })
  }, [])



    const submitForm = () => {


        const body = {
          id: props.id,
          name: name,
          company: company,
          headline: headline,
          details: details,
          published: published,
          livedate: livedate,
          enddate: enddate,
          imageurl: imageurl ? imageurl.replace(process.env.REACT_APP_AWS_LOCATION,"") : imageurl
        }
        console.log(body)
        console.log(JSON.stringify(body))
        apiPost(`intranetoffers/updateoffer`, body)
          .then(response => {if(response.ok){
            response.json().then(result => {
              props.setUpdateOrCreate("n")
            })
            
          }})
          .catch( err => console.log(err) )

        

      }

      return (
      <Container>
        <Row>
            <Col>
              <h1>Update Offer</h1>
            </Col>
        </Row>
        <Form>
          <div className="section">
            <Row>
              <Col md={12}>
                <Form.Check checked={published} onChange={(event) => {setPublished(event.target.checked)}} label="Published" />
              </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.name">
                      <Form.Label>Name</Form.Label>
                      <Form.Control onChange={(event) => setName(event.target.value)} type="text" value={name} />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.company">
                      <Form.Label>Company</Form.Label>
                      <Form.Control onChange={(event) => setCompany(event.target.value)} type="text" value={company} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
            <Col md={6}>
                    <Form.Group controlId="blogCreate.imageurl">
                      <Form.Label>Image URL</Form.Label>
                      <Form.Control onChange={(event) => setImageurl(event.target.value)} type="text" value={imageurl} />
                    </Form.Group>
                    <ImageUploader dirname="draft-offer-images" width={1200} height={628} filename={`oi${props.id}`} filetype={"PNG"} setImageLocation={(url => setImageurl(url))} />
                </Col>
                <Col md={6}>
                    <Form.Group controlId="blogCreate.headline">
                      <Form.Label>Headline</Form.Label>
                      <Form.Control onChange={(event) => setHeadline(event.target.value)} type="text" value={headline} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
              <Col md={6}>
                      <Form.Group controlId="blogCreate.date">
                        <Form.Label>Start Date - Format as YYYY-MM-DD HH:MM</Form.Label>
                        <Form.Control onChange={(event) => setLivedate(event.target.value)} type="text" value={livedate} />
                      </Form.Group> 
              </Col>
              <Col md={6}>
                  <Form.Group controlId="blogCreate.date">
                        <Form.Label>End Date - Format as YYYY-MM-DD HH:MM</Form.Label>
                        <Form.Control onChange={(event) => setEnddate(event.target.value)} type="text" value={enddate} />
                      </Form.Group>   
              </Col>
            </Row>

            <h4>Details</h4>
                <Row>
                        <Col>
                            <ReactQuill style={{marginBottom:"100px", height:"300px"}}
                            value={details}
                            onChange={setDetails}
                            modules={modules}
                            />
                        </Col>
                    </Row>

            <Row>
                <Button onClick={submitForm} style={{marginBottom:"30px"}} className="btn btn-primary">
                  Submit
                </Button>
                <Button onClick={(event) => listOffers(event)} style={{marginBottom:"30px"}}  className="btn btn-primary">
                  Go back
                </Button>
            </Row>
            </div>
        </Form>
      </Container>
      );


    

}

export default CreateOffer;